var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"induction_con"},[_c('p',{staticClass:"c-main-txt font-36 c-m-b-20 c-t-c"},[_vm._v("商品详情")]),_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.textInduction)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }